// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3oaZh","footer":"ReportModalFilter_footer__3VphV"};